// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"08fbe9c5","320":"9b9e1697","375":"b2dcd39b","496":"33cc09f4","647":"3853526c","721":"a95848df","766":"081768a2"}[chunkId] + ".chunk.js";
};